import { format } from 'date-fns';

import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import ListItemText from '@mui/material/ListItemText';

import { useBoolean } from 'src/hooks/use-boolean';

import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';

import { IVirtualCardsTabManagement } from '../../../../types/club-cards';

// ----------------------------------------------------------------------

type Props = {
  selected: boolean;
  onEditRow: VoidFunction;
  row: IVirtualCardsTabManagement;
  onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
};

export default function TabManagementTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
}: Props) {
  const { name, secondName, total, type, date, typeOfTransfer } = row;
  const confirm = useBoolean();

  const quickEdit = useBoolean();

  const popover = usePopover();

  return (
    <>
      <TableRow hover selected={selected}>
        {/* <TableCell padding="checkbox"> */}
        {/*  <Checkbox checked={selected} onClick={onSelectRow} /> */}
        {/* </TableCell> */}

        <TableCell sx={{ whiteSpace: 'nowrap' }}>
          <ListItemText
            primary={name}
            secondary={secondName}
            primaryTypographyProps={{ typography: 'body2' }}
            secondaryTypographyProps={{
              fontSize: 12,
              component: 'p',
              color: 'text.disabled',
            }}
          />
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }}>{typeOfTransfer}</TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }}>{total}</TableCell>

        <TableCell>
          <Label
            variant="soft"
            color={
              (type === 'active' && 'success') ||
              (type === 'pending' && 'warning') ||
              (type === 'banned' && 'error') ||
              'default'
            }
          >
            {type === 'active' ? 'כסף' : 'הטבות וקופונים'}
          </Label>
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' }}>
          <ListItemText
            primary={format(new Date(date), 'dd.MM.yyyy')}
            secondary={format(new Date(date), 'HH:mm a')}
            primaryTypographyProps={{ typography: 'body2' }}
            secondaryTypographyProps={{
              fontSize: 12,
              component: 'p',
              color: 'text.disabled',
            }}
          />
        </TableCell>
      </TableRow>

      {/* <UserQuickEditForm currentUser={row} open={quickEdit.value} onClose={quickEdit.onFalse} /> */}

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>

        <MenuItem
          onClick={() => {
            onEditRow();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      />
    </>
  );
}
